import "./sprinkles.css.ts.vanilla.js";
import { createSprinkles as a } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
var f = a({
    conditions: void 0,
    styles: {
        padding: {
            mappings: [
                "paddingTop",
                "paddingBottom",
                "paddingLeft",
                "paddingRight"
            ]
        },
        paddingX: {
            mappings: [
                "paddingLeft",
                "paddingRight"
            ]
        },
        paddingY: {
            mappings: [
                "paddingTop",
                "paddingBottom"
            ]
        },
        position: {
            values: {
                relative: {
                    defaultClass: "_1y2v1nf5d"
                },
                absolute: {
                    defaultClass: "_1y2v1nf5e"
                },
                fixed: {
                    defaultClass: "_1y2v1nf5f"
                },
                static: {
                    defaultClass: "_1y2v1nf5g"
                }
            }
        },
        display: {
            values: {
                none: {
                    defaultClass: "_1y2v1nf5h"
                },
                flex: {
                    defaultClass: "_1y2v1nf5i"
                },
                "inline-flex": {
                    defaultClass: "_1y2v1nf5j"
                },
                block: {
                    defaultClass: "_1y2v1nf5k"
                },
                inline: {
                    defaultClass: "_1y2v1nf5l"
                },
                "inline-block": {
                    defaultClass: "_1y2v1nf5m"
                }
            }
        },
        flexDirection: {
            values: {
                row: {
                    defaultClass: "_1y2v1nf5n"
                },
                column: {
                    defaultClass: "_1y2v1nf5o"
                }
            }
        },
        justifyContent: {
            values: {
                stretch: {
                    defaultClass: "_1y2v1nf5p"
                },
                "flex-start": {
                    defaultClass: "_1y2v1nf5q"
                },
                center: {
                    defaultClass: "_1y2v1nf5r"
                },
                "flex-end": {
                    defaultClass: "_1y2v1nf5s"
                },
                "space-around": {
                    defaultClass: "_1y2v1nf5t"
                },
                "space-between": {
                    defaultClass: "_1y2v1nf5u"
                }
            }
        },
        alignItems: {
            values: {
                stretch: {
                    defaultClass: "_1y2v1nf5v"
                },
                "flex-start": {
                    defaultClass: "_1y2v1nf5w"
                },
                center: {
                    defaultClass: "_1y2v1nf5x"
                },
                "flex-end": {
                    defaultClass: "_1y2v1nf5y"
                },
                baseline: {
                    defaultClass: "_1y2v1nf5z"
                }
            }
        },
        flexShrink: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf60"
                },
                1: {
                    defaultClass: "_1y2v1nf61"
                }
            }
        },
        flexGrow: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf62"
                },
                1: {
                    defaultClass: "_1y2v1nf63"
                }
            }
        },
        flex: {
            values: {
                1: {
                    defaultClass: "_1y2v1nf64"
                }
            }
        },
        paddingTop: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf65"
                },
                2: {
                    defaultClass: "_1y2v1nf66"
                },
                4: {
                    defaultClass: "_1y2v1nf67"
                },
                8: {
                    defaultClass: "_1y2v1nf68"
                },
                12: {
                    defaultClass: "_1y2v1nf69"
                },
                16: {
                    defaultClass: "_1y2v1nf6a"
                },
                24: {
                    defaultClass: "_1y2v1nf6b"
                },
                32: {
                    defaultClass: "_1y2v1nf6c"
                },
                40: {
                    defaultClass: "_1y2v1nf6d"
                },
                48: {
                    defaultClass: "_1y2v1nf6e"
                },
                56: {
                    defaultClass: "_1y2v1nf6f"
                },
                64: {
                    defaultClass: "_1y2v1nf6g"
                },
                72: {
                    defaultClass: "_1y2v1nf6h"
                },
                80: {
                    defaultClass: "_1y2v1nf6i"
                }
            }
        },
        paddingBottom: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf6j"
                },
                2: {
                    defaultClass: "_1y2v1nf6k"
                },
                4: {
                    defaultClass: "_1y2v1nf6l"
                },
                8: {
                    defaultClass: "_1y2v1nf6m"
                },
                12: {
                    defaultClass: "_1y2v1nf6n"
                },
                16: {
                    defaultClass: "_1y2v1nf6o"
                },
                24: {
                    defaultClass: "_1y2v1nf6p"
                },
                32: {
                    defaultClass: "_1y2v1nf6q"
                },
                40: {
                    defaultClass: "_1y2v1nf6r"
                },
                48: {
                    defaultClass: "_1y2v1nf6s"
                },
                56: {
                    defaultClass: "_1y2v1nf6t"
                },
                64: {
                    defaultClass: "_1y2v1nf6u"
                },
                72: {
                    defaultClass: "_1y2v1nf6v"
                },
                80: {
                    defaultClass: "_1y2v1nf6w"
                }
            }
        },
        paddingLeft: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf6x"
                },
                2: {
                    defaultClass: "_1y2v1nf6y"
                },
                4: {
                    defaultClass: "_1y2v1nf6z"
                },
                8: {
                    defaultClass: "_1y2v1nf70"
                },
                12: {
                    defaultClass: "_1y2v1nf71"
                },
                16: {
                    defaultClass: "_1y2v1nf72"
                },
                24: {
                    defaultClass: "_1y2v1nf73"
                },
                32: {
                    defaultClass: "_1y2v1nf74"
                },
                40: {
                    defaultClass: "_1y2v1nf75"
                },
                48: {
                    defaultClass: "_1y2v1nf76"
                },
                56: {
                    defaultClass: "_1y2v1nf77"
                },
                64: {
                    defaultClass: "_1y2v1nf78"
                },
                72: {
                    defaultClass: "_1y2v1nf79"
                },
                80: {
                    defaultClass: "_1y2v1nf7a"
                }
            }
        },
        paddingRight: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf7b"
                },
                2: {
                    defaultClass: "_1y2v1nf7c"
                },
                4: {
                    defaultClass: "_1y2v1nf7d"
                },
                8: {
                    defaultClass: "_1y2v1nf7e"
                },
                12: {
                    defaultClass: "_1y2v1nf7f"
                },
                16: {
                    defaultClass: "_1y2v1nf7g"
                },
                24: {
                    defaultClass: "_1y2v1nf7h"
                },
                32: {
                    defaultClass: "_1y2v1nf7i"
                },
                40: {
                    defaultClass: "_1y2v1nf7j"
                },
                48: {
                    defaultClass: "_1y2v1nf7k"
                },
                56: {
                    defaultClass: "_1y2v1nf7l"
                },
                64: {
                    defaultClass: "_1y2v1nf7m"
                },
                72: {
                    defaultClass: "_1y2v1nf7n"
                },
                80: {
                    defaultClass: "_1y2v1nf7o"
                }
            }
        },
        width: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf7r"
                },
                2: {
                    defaultClass: "_1y2v1nf7s"
                },
                4: {
                    defaultClass: "_1y2v1nf7t"
                },
                8: {
                    defaultClass: "_1y2v1nf7u"
                },
                12: {
                    defaultClass: "_1y2v1nf7v"
                },
                16: {
                    defaultClass: "_1y2v1nf7w"
                },
                24: {
                    defaultClass: "_1y2v1nf7x"
                },
                32: {
                    defaultClass: "_1y2v1nf7y"
                },
                40: {
                    defaultClass: "_1y2v1nf7z"
                },
                48: {
                    defaultClass: "_1y2v1nf80"
                },
                56: {
                    defaultClass: "_1y2v1nf81"
                },
                64: {
                    defaultClass: "_1y2v1nf82"
                },
                72: {
                    defaultClass: "_1y2v1nf83"
                },
                80: {
                    defaultClass: "_1y2v1nf84"
                },
                "100%": {
                    defaultClass: "_1y2v1nf7p"
                },
                auto: {
                    defaultClass: "_1y2v1nf7q"
                }
            }
        },
        height: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf86"
                },
                2: {
                    defaultClass: "_1y2v1nf87"
                },
                4: {
                    defaultClass: "_1y2v1nf88"
                },
                8: {
                    defaultClass: "_1y2v1nf89"
                },
                12: {
                    defaultClass: "_1y2v1nf8a"
                },
                16: {
                    defaultClass: "_1y2v1nf8b"
                },
                24: {
                    defaultClass: "_1y2v1nf8c"
                },
                32: {
                    defaultClass: "_1y2v1nf8d"
                },
                40: {
                    defaultClass: "_1y2v1nf8e"
                },
                48: {
                    defaultClass: "_1y2v1nf8f"
                },
                56: {
                    defaultClass: "_1y2v1nf8g"
                },
                64: {
                    defaultClass: "_1y2v1nf8h"
                },
                72: {
                    defaultClass: "_1y2v1nf8i"
                },
                80: {
                    defaultClass: "_1y2v1nf8j"
                },
                "100%": {
                    defaultClass: "_1y2v1nf85"
                }
            }
        },
        minWidth: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf8l"
                },
                2: {
                    defaultClass: "_1y2v1nf8m"
                },
                4: {
                    defaultClass: "_1y2v1nf8n"
                },
                8: {
                    defaultClass: "_1y2v1nf8o"
                },
                12: {
                    defaultClass: "_1y2v1nf8p"
                },
                16: {
                    defaultClass: "_1y2v1nf8q"
                },
                24: {
                    defaultClass: "_1y2v1nf8r"
                },
                32: {
                    defaultClass: "_1y2v1nf8s"
                },
                40: {
                    defaultClass: "_1y2v1nf8t"
                },
                48: {
                    defaultClass: "_1y2v1nf8u"
                },
                56: {
                    defaultClass: "_1y2v1nf8v"
                },
                64: {
                    defaultClass: "_1y2v1nf8w"
                },
                72: {
                    defaultClass: "_1y2v1nf8x"
                },
                80: {
                    defaultClass: "_1y2v1nf8y"
                },
                "100%": {
                    defaultClass: "_1y2v1nf8k"
                }
            }
        },
        minHeight: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf8z"
                },
                2: {
                    defaultClass: "_1y2v1nf90"
                },
                4: {
                    defaultClass: "_1y2v1nf91"
                },
                8: {
                    defaultClass: "_1y2v1nf92"
                },
                12: {
                    defaultClass: "_1y2v1nf93"
                },
                16: {
                    defaultClass: "_1y2v1nf94"
                },
                24: {
                    defaultClass: "_1y2v1nf95"
                },
                32: {
                    defaultClass: "_1y2v1nf96"
                },
                40: {
                    defaultClass: "_1y2v1nf97"
                },
                48: {
                    defaultClass: "_1y2v1nf98"
                },
                56: {
                    defaultClass: "_1y2v1nf99"
                },
                64: {
                    defaultClass: "_1y2v1nf9a"
                },
                72: {
                    defaultClass: "_1y2v1nf9b"
                },
                80: {
                    defaultClass: "_1y2v1nf9c"
                }
            }
        },
        maxWidth: {
            values: {
                "100%": {
                    defaultClass: "_1y2v1nf9d"
                }
            }
        },
        maxHeight: {
            values: {
                "100%": {
                    defaultClass: "_1y2v1nf9e"
                }
            }
        },
        border: {
            values: {
                regular: {
                    defaultClass: "_1y2v1nf9f"
                },
                none: {
                    defaultClass: "_1y2v1nf9g"
                }
            }
        },
        borderRadius: {
            values: {
                2: {
                    defaultClass: "_1y2v1nf9i"
                },
                4: {
                    defaultClass: "_1y2v1nf9j"
                },
                8: {
                    defaultClass: "_1y2v1nf9k"
                },
                16: {
                    defaultClass: "_1y2v1nf9l"
                },
                20: {
                    defaultClass: "_1y2v1nf9m"
                },
                "50%": {
                    defaultClass: "_1y2v1nf9h"
                }
            }
        },
        cursor: {
            values: {
                pointer: {
                    defaultClass: "_1y2v1nf9n"
                }
            }
        },
        overflow: {
            values: {
                hidden: {
                    defaultClass: "_1y2v1nf9o"
                },
                visible: {
                    defaultClass: "_1y2v1nf9p"
                }
            }
        },
        top: {
            values: {
                0: {
                    defaultClass: "_1y2v1nf9q"
                },
                2: {
                    defaultClass: "_1y2v1nf9r"
                },
                4: {
                    defaultClass: "_1y2v1nf9s"
                },
                8: {
                    defaultClass: "_1y2v1nf9t"
                },
                12: {
                    defaultClass: "_1y2v1nf9u"
                },
                16: {
                    defaultClass: "_1y2v1nf9v"
                },
                24: {
                    defaultClass: "_1y2v1nf9w"
                },
                32: {
                    defaultClass: "_1y2v1nf9x"
                },
                40: {
                    defaultClass: "_1y2v1nf9y"
                },
                48: {
                    defaultClass: "_1y2v1nf9z"
                },
                56: {
                    defaultClass: "_1y2v1nfa0"
                },
                64: {
                    defaultClass: "_1y2v1nfa1"
                },
                72: {
                    defaultClass: "_1y2v1nfa2"
                },
                80: {
                    defaultClass: "_1y2v1nfa3"
                }
            }
        },
        left: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfa4"
                },
                2: {
                    defaultClass: "_1y2v1nfa5"
                },
                4: {
                    defaultClass: "_1y2v1nfa6"
                },
                8: {
                    defaultClass: "_1y2v1nfa7"
                },
                12: {
                    defaultClass: "_1y2v1nfa8"
                },
                16: {
                    defaultClass: "_1y2v1nfa9"
                },
                24: {
                    defaultClass: "_1y2v1nfaa"
                },
                32: {
                    defaultClass: "_1y2v1nfab"
                },
                40: {
                    defaultClass: "_1y2v1nfac"
                },
                48: {
                    defaultClass: "_1y2v1nfad"
                },
                56: {
                    defaultClass: "_1y2v1nfae"
                },
                64: {
                    defaultClass: "_1y2v1nfaf"
                },
                72: {
                    defaultClass: "_1y2v1nfag"
                },
                80: {
                    defaultClass: "_1y2v1nfah"
                }
            }
        },
        right: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfai"
                },
                2: {
                    defaultClass: "_1y2v1nfaj"
                },
                4: {
                    defaultClass: "_1y2v1nfak"
                },
                8: {
                    defaultClass: "_1y2v1nfal"
                },
                12: {
                    defaultClass: "_1y2v1nfam"
                },
                16: {
                    defaultClass: "_1y2v1nfan"
                },
                24: {
                    defaultClass: "_1y2v1nfao"
                },
                32: {
                    defaultClass: "_1y2v1nfap"
                },
                40: {
                    defaultClass: "_1y2v1nfaq"
                },
                48: {
                    defaultClass: "_1y2v1nfar"
                },
                56: {
                    defaultClass: "_1y2v1nfas"
                },
                64: {
                    defaultClass: "_1y2v1nfat"
                },
                72: {
                    defaultClass: "_1y2v1nfau"
                },
                80: {
                    defaultClass: "_1y2v1nfav"
                }
            }
        },
        bottom: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfaw"
                },
                2: {
                    defaultClass: "_1y2v1nfax"
                },
                4: {
                    defaultClass: "_1y2v1nfay"
                },
                8: {
                    defaultClass: "_1y2v1nfaz"
                },
                12: {
                    defaultClass: "_1y2v1nfb0"
                },
                16: {
                    defaultClass: "_1y2v1nfb1"
                },
                24: {
                    defaultClass: "_1y2v1nfb2"
                },
                32: {
                    defaultClass: "_1y2v1nfb3"
                },
                40: {
                    defaultClass: "_1y2v1nfb4"
                },
                48: {
                    defaultClass: "_1y2v1nfb5"
                },
                56: {
                    defaultClass: "_1y2v1nfb6"
                },
                64: {
                    defaultClass: "_1y2v1nfb7"
                },
                72: {
                    defaultClass: "_1y2v1nfb8"
                },
                80: {
                    defaultClass: "_1y2v1nfb9"
                }
            }
        },
        objectFit: {
            values: {
                cover: {
                    defaultClass: "_1y2v1nfba"
                }
            }
        }
    }
}, {
    conditions: void 0,
    styles: {
        color: {
            values: {
                "var(--_1vqcj1i0)": {
                    defaultClass: "_1y2v1nf0"
                },
                "var(--_1vqcj1i1)": {
                    defaultClass: "_1y2v1nf1"
                },
                "var(--_1vqcj1i2)": {
                    defaultClass: "_1y2v1nf2"
                },
                "var(--_1vqcj1i3)": {
                    defaultClass: "_1y2v1nf3"
                },
                "var(--_1vqcj1i4)": {
                    defaultClass: "_1y2v1nf4"
                },
                "var(--_1vqcj1i5)": {
                    defaultClass: "_1y2v1nf5"
                },
                "var(--_1vqcj1i6)": {
                    defaultClass: "_1y2v1nf6"
                },
                "var(--_1vqcj1i7)": {
                    defaultClass: "_1y2v1nf7"
                },
                "var(--_1vqcj1i8)": {
                    defaultClass: "_1y2v1nf8"
                },
                "var(--_1vqcj1i9)": {
                    defaultClass: "_1y2v1nf9"
                },
                "var(--_1vqcj1ia)": {
                    defaultClass: "_1y2v1nfa"
                },
                "var(--_1vqcj1ib)": {
                    defaultClass: "_1y2v1nfb"
                },
                "var(--_1vqcj1ic)": {
                    defaultClass: "_1y2v1nfc"
                },
                "var(--_1vqcj1id)": {
                    defaultClass: "_1y2v1nfd"
                },
                "var(--_1vqcj1ie)": {
                    defaultClass: "_1y2v1nfe"
                },
                "var(--_1vqcj1if)": {
                    defaultClass: "_1y2v1nff"
                },
                "var(--_1vqcj1ig)": {
                    defaultClass: "_1y2v1nfg"
                },
                "var(--_1vqcj1ih)": {
                    defaultClass: "_1y2v1nfh"
                },
                "var(--_1vqcj1ii)": {
                    defaultClass: "_1y2v1nfi"
                },
                "var(--_1vqcj1ij)": {
                    defaultClass: "_1y2v1nfj"
                },
                "var(--_1vqcj1ik)": {
                    defaultClass: "_1y2v1nfk"
                },
                "var(--_1vqcj1il)": {
                    defaultClass: "_1y2v1nfl"
                },
                "var(--_1vqcj1im)": {
                    defaultClass: "_1y2v1nfm"
                },
                "var(--_1vqcj1in)": {
                    defaultClass: "_1y2v1nfn"
                },
                "var(--_1vqcj1io)": {
                    defaultClass: "_1y2v1nfo"
                },
                "var(--_1vqcj1ip)": {
                    defaultClass: "_1y2v1nfp"
                },
                "var(--_1vqcj1iq)": {
                    defaultClass: "_1y2v1nfq"
                },
                "var(--_1vqcj1ir)": {
                    defaultClass: "_1y2v1nfr"
                },
                "var(--_1vqcj1is)": {
                    defaultClass: "_1y2v1nfs"
                },
                "var(--_1vqcj1it)": {
                    defaultClass: "_1y2v1nft"
                },
                "var(--_1vqcj1iu)": {
                    defaultClass: "_1y2v1nfu"
                },
                "var(--_1vqcj1iv)": {
                    defaultClass: "_1y2v1nfv"
                },
                "var(--_1vqcj1iw)": {
                    defaultClass: "_1y2v1nfw"
                },
                "var(--_1vqcj1ix)": {
                    defaultClass: "_1y2v1nfx"
                },
                "var(--_1vqcj1iy)": {
                    defaultClass: "_1y2v1nfy"
                },
                "var(--_1vqcj1iz)": {
                    defaultClass: "_1y2v1nfz"
                },
                "var(--_1vqcj1i10)": {
                    defaultClass: "_1y2v1nf10"
                },
                "var(--_1vqcj1i11)": {
                    defaultClass: "_1y2v1nf11"
                },
                "var(--_1vqcj1i12)": {
                    defaultClass: "_1y2v1nf12"
                },
                "var(--_1vqcj1i13)": {
                    defaultClass: "_1y2v1nf13"
                },
                "var(--_1vqcj1i14)": {
                    defaultClass: "_1y2v1nf14"
                },
                "var(--_1vqcj1i15)": {
                    defaultClass: "_1y2v1nf15"
                },
                "var(--_1vqcj1i16)": {
                    defaultClass: "_1y2v1nf16"
                },
                "var(--_1vqcj1i17)": {
                    defaultClass: "_1y2v1nf17"
                },
                "var(--_1vqcj1i18)": {
                    defaultClass: "_1y2v1nf18"
                },
                "var(--_1vqcj1i19)": {
                    defaultClass: "_1y2v1nf19"
                },
                "var(--_1vqcj1i1a)": {
                    defaultClass: "_1y2v1nf1a"
                },
                "var(--_1vqcj1i1b)": {
                    defaultClass: "_1y2v1nf1b"
                },
                "var(--_1vqcj1i1c)": {
                    defaultClass: "_1y2v1nf1c"
                },
                "var(--_1vqcj1i1d)": {
                    defaultClass: "_1y2v1nf1d"
                },
                "var(--_1vqcj1i1e)": {
                    defaultClass: "_1y2v1nf1e"
                },
                "var(--_1vqcj1i1f)": {
                    defaultClass: "_1y2v1nf1f"
                },
                "var(--_1vqcj1i1g)": {
                    defaultClass: "_1y2v1nf1g"
                },
                "var(--_1vqcj1i1h)": {
                    defaultClass: "_1y2v1nf1h"
                },
                "var(--_1vqcj1i1i)": {
                    defaultClass: "_1y2v1nf1i"
                },
                "var(--_1vqcj1i1j)": {
                    defaultClass: "_1y2v1nf1j"
                },
                "var(--_1vqcj1i1k)": {
                    defaultClass: "_1y2v1nf1k"
                },
                "var(--_1vqcj1i1l)": {
                    defaultClass: "_1y2v1nf1l"
                },
                "var(--_1vqcj1i1m)": {
                    defaultClass: "_1y2v1nf1m"
                },
                "var(--_1vqcj1i1n)": {
                    defaultClass: "_1y2v1nf1n"
                },
                "var(--_1vqcj1i1o)": {
                    defaultClass: "_1y2v1nf1o"
                },
                "var(--_1vqcj1i1p)": {
                    defaultClass: "_1y2v1nf1p"
                },
                "var(--_1vqcj1i1q)": {
                    defaultClass: "_1y2v1nf1q"
                },
                "var(--_1vqcj1i1r)": {
                    defaultClass: "_1y2v1nf1r"
                },
                "var(--_1vqcj1i1s)": {
                    defaultClass: "_1y2v1nf1s"
                },
                "var(--_1vqcj1i1t)": {
                    defaultClass: "_1y2v1nf1t"
                },
                "var(--_1vqcj1i1u)": {
                    defaultClass: "_1y2v1nf1u"
                },
                "var(--_1vqcj1i1v)": {
                    defaultClass: "_1y2v1nf1v"
                },
                "var(--_1vqcj1i1w)": {
                    defaultClass: "_1y2v1nf1w"
                },
                "var(--_1vqcj1i1x)": {
                    defaultClass: "_1y2v1nf1x"
                },
                "var(--_1vqcj1i1y)": {
                    defaultClass: "_1y2v1nf1y"
                },
                "var(--_1vqcj1i1z)": {
                    defaultClass: "_1y2v1nf1z"
                },
                "var(--_1vqcj1i20)": {
                    defaultClass: "_1y2v1nf20"
                },
                "var(--_1vqcj1i21)": {
                    defaultClass: "_1y2v1nf21"
                },
                "var(--_1vqcj1i22)": {
                    defaultClass: "_1y2v1nf22"
                },
                "var(--_1vqcj1i23)": {
                    defaultClass: "_1y2v1nf23"
                },
                "var(--_1vqcj1i24)": {
                    defaultClass: "_1y2v1nf24"
                },
                "var(--_1vqcj1i25)": {
                    defaultClass: "_1y2v1nf25"
                },
                "var(--_1vqcj1i26)": {
                    defaultClass: "_1y2v1nf26"
                },
                "var(--_1vqcj1i27)": {
                    defaultClass: "_1y2v1nf27"
                },
                "var(--_1vqcj1i28)": {
                    defaultClass: "_1y2v1nf28"
                },
                "var(--_1vqcj1i29)": {
                    defaultClass: "_1y2v1nf29"
                },
                "var(--_1vqcj1i2a)": {
                    defaultClass: "_1y2v1nf2a"
                },
                "var(--_1vqcj1i2b)": {
                    defaultClass: "_1y2v1nf2b"
                },
                "var(--_1vqcj1i2c)": {
                    defaultClass: "_1y2v1nf2c"
                },
                "var(--_1vqcj1i2d)": {
                    defaultClass: "_1y2v1nf2d"
                },
                "var(--_1vqcj1i2e)": {
                    defaultClass: "_1y2v1nf2e"
                },
                "var(--_1vqcj1i2f)": {
                    defaultClass: "_1y2v1nf2f"
                },
                "var(--_1vqcj1i2g)": {
                    defaultClass: "_1y2v1nf2g"
                },
                "var(--_1vqcj1i2h)": {
                    defaultClass: "_1y2v1nf2h"
                },
                "var(--_1vqcj1i2i)": {
                    defaultClass: "_1y2v1nf2i"
                },
                "var(--_1vqcj1i2j)": {
                    defaultClass: "_1y2v1nf2j"
                },
                "var(--_1vqcj1i2k)": {
                    defaultClass: "_1y2v1nf2k"
                },
                "var(--_1vqcj1i2l)": {
                    defaultClass: "_1y2v1nf2l"
                },
                transparent: {
                    defaultClass: "_1y2v1nf2m"
                },
                inherit: {
                    defaultClass: "_1y2v1nf2n"
                }
            }
        },
        background: {
            values: {
                "var(--_1vqcj1i0)": {
                    defaultClass: "_1y2v1nf2o"
                },
                "var(--_1vqcj1i1)": {
                    defaultClass: "_1y2v1nf2p"
                },
                "var(--_1vqcj1i2)": {
                    defaultClass: "_1y2v1nf2q"
                },
                "var(--_1vqcj1i3)": {
                    defaultClass: "_1y2v1nf2r"
                },
                "var(--_1vqcj1i4)": {
                    defaultClass: "_1y2v1nf2s"
                },
                "var(--_1vqcj1i5)": {
                    defaultClass: "_1y2v1nf2t"
                },
                "var(--_1vqcj1i6)": {
                    defaultClass: "_1y2v1nf2u"
                },
                "var(--_1vqcj1i7)": {
                    defaultClass: "_1y2v1nf2v"
                },
                "var(--_1vqcj1i8)": {
                    defaultClass: "_1y2v1nf2w"
                },
                "var(--_1vqcj1i9)": {
                    defaultClass: "_1y2v1nf2x"
                },
                "var(--_1vqcj1ia)": {
                    defaultClass: "_1y2v1nf2y"
                },
                "var(--_1vqcj1ib)": {
                    defaultClass: "_1y2v1nf2z"
                },
                "var(--_1vqcj1ic)": {
                    defaultClass: "_1y2v1nf30"
                },
                "var(--_1vqcj1id)": {
                    defaultClass: "_1y2v1nf31"
                },
                "var(--_1vqcj1ie)": {
                    defaultClass: "_1y2v1nf32"
                },
                "var(--_1vqcj1if)": {
                    defaultClass: "_1y2v1nf33"
                },
                "var(--_1vqcj1ig)": {
                    defaultClass: "_1y2v1nf34"
                },
                "var(--_1vqcj1ih)": {
                    defaultClass: "_1y2v1nf35"
                },
                "var(--_1vqcj1ii)": {
                    defaultClass: "_1y2v1nf36"
                },
                "var(--_1vqcj1ij)": {
                    defaultClass: "_1y2v1nf37"
                },
                "var(--_1vqcj1ik)": {
                    defaultClass: "_1y2v1nf38"
                },
                "var(--_1vqcj1il)": {
                    defaultClass: "_1y2v1nf39"
                },
                "var(--_1vqcj1im)": {
                    defaultClass: "_1y2v1nf3a"
                },
                "var(--_1vqcj1in)": {
                    defaultClass: "_1y2v1nf3b"
                },
                "var(--_1vqcj1io)": {
                    defaultClass: "_1y2v1nf3c"
                },
                "var(--_1vqcj1ip)": {
                    defaultClass: "_1y2v1nf3d"
                },
                "var(--_1vqcj1iq)": {
                    defaultClass: "_1y2v1nf3e"
                },
                "var(--_1vqcj1ir)": {
                    defaultClass: "_1y2v1nf3f"
                },
                "var(--_1vqcj1is)": {
                    defaultClass: "_1y2v1nf3g"
                },
                "var(--_1vqcj1it)": {
                    defaultClass: "_1y2v1nf3h"
                },
                "var(--_1vqcj1iu)": {
                    defaultClass: "_1y2v1nf3i"
                },
                "var(--_1vqcj1iv)": {
                    defaultClass: "_1y2v1nf3j"
                },
                "var(--_1vqcj1iw)": {
                    defaultClass: "_1y2v1nf3k"
                },
                "var(--_1vqcj1ix)": {
                    defaultClass: "_1y2v1nf3l"
                },
                "var(--_1vqcj1iy)": {
                    defaultClass: "_1y2v1nf3m"
                },
                "var(--_1vqcj1iz)": {
                    defaultClass: "_1y2v1nf3n"
                },
                "var(--_1vqcj1i10)": {
                    defaultClass: "_1y2v1nf3o"
                },
                "var(--_1vqcj1i11)": {
                    defaultClass: "_1y2v1nf3p"
                },
                "var(--_1vqcj1i12)": {
                    defaultClass: "_1y2v1nf3q"
                },
                "var(--_1vqcj1i13)": {
                    defaultClass: "_1y2v1nf3r"
                },
                "var(--_1vqcj1i14)": {
                    defaultClass: "_1y2v1nf3s"
                },
                "var(--_1vqcj1i15)": {
                    defaultClass: "_1y2v1nf3t"
                },
                "var(--_1vqcj1i16)": {
                    defaultClass: "_1y2v1nf3u"
                },
                "var(--_1vqcj1i17)": {
                    defaultClass: "_1y2v1nf3v"
                },
                "var(--_1vqcj1i18)": {
                    defaultClass: "_1y2v1nf3w"
                },
                "var(--_1vqcj1i19)": {
                    defaultClass: "_1y2v1nf3x"
                },
                "var(--_1vqcj1i1a)": {
                    defaultClass: "_1y2v1nf3y"
                },
                "var(--_1vqcj1i1b)": {
                    defaultClass: "_1y2v1nf3z"
                },
                "var(--_1vqcj1i1c)": {
                    defaultClass: "_1y2v1nf40"
                },
                "var(--_1vqcj1i1d)": {
                    defaultClass: "_1y2v1nf41"
                },
                "var(--_1vqcj1i1e)": {
                    defaultClass: "_1y2v1nf42"
                },
                "var(--_1vqcj1i1f)": {
                    defaultClass: "_1y2v1nf43"
                },
                "var(--_1vqcj1i1g)": {
                    defaultClass: "_1y2v1nf44"
                },
                "var(--_1vqcj1i1h)": {
                    defaultClass: "_1y2v1nf45"
                },
                "var(--_1vqcj1i1i)": {
                    defaultClass: "_1y2v1nf46"
                },
                "var(--_1vqcj1i1j)": {
                    defaultClass: "_1y2v1nf47"
                },
                "var(--_1vqcj1i1k)": {
                    defaultClass: "_1y2v1nf48"
                },
                "var(--_1vqcj1i1l)": {
                    defaultClass: "_1y2v1nf49"
                },
                "var(--_1vqcj1i1m)": {
                    defaultClass: "_1y2v1nf4a"
                },
                "var(--_1vqcj1i1n)": {
                    defaultClass: "_1y2v1nf4b"
                },
                "var(--_1vqcj1i1o)": {
                    defaultClass: "_1y2v1nf4c"
                },
                "var(--_1vqcj1i1p)": {
                    defaultClass: "_1y2v1nf4d"
                },
                "var(--_1vqcj1i1q)": {
                    defaultClass: "_1y2v1nf4e"
                },
                "var(--_1vqcj1i1r)": {
                    defaultClass: "_1y2v1nf4f"
                },
                "var(--_1vqcj1i1s)": {
                    defaultClass: "_1y2v1nf4g"
                },
                "var(--_1vqcj1i1t)": {
                    defaultClass: "_1y2v1nf4h"
                },
                "var(--_1vqcj1i1u)": {
                    defaultClass: "_1y2v1nf4i"
                },
                "var(--_1vqcj1i1v)": {
                    defaultClass: "_1y2v1nf4j"
                },
                "var(--_1vqcj1i1w)": {
                    defaultClass: "_1y2v1nf4k"
                },
                "var(--_1vqcj1i1x)": {
                    defaultClass: "_1y2v1nf4l"
                },
                "var(--_1vqcj1i1y)": {
                    defaultClass: "_1y2v1nf4m"
                },
                "var(--_1vqcj1i1z)": {
                    defaultClass: "_1y2v1nf4n"
                },
                "var(--_1vqcj1i20)": {
                    defaultClass: "_1y2v1nf4o"
                },
                "var(--_1vqcj1i21)": {
                    defaultClass: "_1y2v1nf4p"
                },
                "var(--_1vqcj1i22)": {
                    defaultClass: "_1y2v1nf4q"
                },
                "var(--_1vqcj1i23)": {
                    defaultClass: "_1y2v1nf4r"
                },
                "var(--_1vqcj1i24)": {
                    defaultClass: "_1y2v1nf4s"
                },
                "var(--_1vqcj1i25)": {
                    defaultClass: "_1y2v1nf4t"
                },
                "var(--_1vqcj1i26)": {
                    defaultClass: "_1y2v1nf4u"
                },
                "var(--_1vqcj1i27)": {
                    defaultClass: "_1y2v1nf4v"
                },
                "var(--_1vqcj1i28)": {
                    defaultClass: "_1y2v1nf4w"
                },
                "var(--_1vqcj1i29)": {
                    defaultClass: "_1y2v1nf4x"
                },
                "var(--_1vqcj1i2a)": {
                    defaultClass: "_1y2v1nf4y"
                },
                "var(--_1vqcj1i2b)": {
                    defaultClass: "_1y2v1nf4z"
                },
                "var(--_1vqcj1i2c)": {
                    defaultClass: "_1y2v1nf50"
                },
                "var(--_1vqcj1i2d)": {
                    defaultClass: "_1y2v1nf51"
                },
                "var(--_1vqcj1i2e)": {
                    defaultClass: "_1y2v1nf52"
                },
                "var(--_1vqcj1i2f)": {
                    defaultClass: "_1y2v1nf53"
                },
                "var(--_1vqcj1i2g)": {
                    defaultClass: "_1y2v1nf54"
                },
                "var(--_1vqcj1i2h)": {
                    defaultClass: "_1y2v1nf55"
                },
                "var(--_1vqcj1i2i)": {
                    defaultClass: "_1y2v1nf56"
                },
                "var(--_1vqcj1i2j)": {
                    defaultClass: "_1y2v1nf57"
                },
                "var(--_1vqcj1i2k)": {
                    defaultClass: "_1y2v1nf58"
                },
                "var(--_1vqcj1i2l)": {
                    defaultClass: "_1y2v1nf59"
                },
                transparent: {
                    defaultClass: "_1y2v1nf5c"
                },
                inherit: {
                    defaultClass: "_1y2v1nf5b"
                }
            }
        }
    }
});
export { f as sprinkles };
